/** The raw administrative decision fields both formatters read, in the shape of agent-v2 administrative decision references. */
export type AdministrativeDecisionDisplayFields = {
  title: string
  citation: string | null
  agency_code: string
  document_type: string | null
  publication_date: string | null
  document_metadata: { source_name?: string | null }
}

/** Administrative decision title, followed by its citation when it has one. */
export function formatAdministrativeDecisionTitle(fields: AdministrativeDecisionDisplayFields): string {
  return fields.citation ? `${fields.title} — ${fields.citation}` : fields.title
}

/**
 * The metadata line shown under an administrative decision title: readable document type, full source
 * name (or the agency code when the catalog has no name), and publication date.
 */
export function formatAdministrativeDecisionMetadataLine(fields: AdministrativeDecisionDisplayFields): string {
  const parts: string[] = []
  if (fields.document_type) parts.push(capitalize(fields.document_type.replaceAll('_', ' ')))
  parts.push(fields.document_metadata.source_name || fields.agency_code.toUpperCase())
  if (fields.publication_date) parts.push(fields.publication_date)
  return parts.join(' • ')
}

function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1)
}
